import script from "./preview.vue?vue&type=script&setup=true&lang=js"
export * from "./preview.vue?vue&type=script&setup=true&lang=js"

import "./preview.vue?vue&type=style&index=0&id=ceb1e7c2&scoped=true&lang=css"

import exportComponent from "/root/.jenkins/workspace/prod-market-pc-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ceb1e7c2"]])

export default __exports__